/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ShapeRectHIcon16Light } from './ShapeRectHIcon16Light';
import { ShapeRectHIcon16Regular } from './ShapeRectHIcon16Regular';
import { ShapeRectHIcon16Solid } from './ShapeRectHIcon16Solid';
import { ShapeRectHIcon20Light } from './ShapeRectHIcon20Light';
import { ShapeRectHIcon20Regular } from './ShapeRectHIcon20Regular';
import { ShapeRectHIcon20Solid } from './ShapeRectHIcon20Solid';
import { ShapeRectHIcon24Regular } from './ShapeRectHIcon24Regular';
import { ShapeRectHIcon24Solid } from './ShapeRectHIcon24Solid';
import { ShapeRectHIcon32Regular } from './ShapeRectHIcon32Regular';
import { ShapeRectHIcon64Regular } from './ShapeRectHIcon64Regular';
var sizes = {
    16: {
        light: ShapeRectHIcon16Light,
        regular: ShapeRectHIcon16Regular,
        solid: ShapeRectHIcon16Solid,
    },
    20: {
        light: ShapeRectHIcon20Light,
        regular: ShapeRectHIcon20Regular,
        solid: ShapeRectHIcon20Solid,
    },
    24: {
        regular: ShapeRectHIcon24Regular,
        solid: ShapeRectHIcon24Solid,
    },
    32: {
        regular: ShapeRectHIcon32Regular,
    },
    64: {
        regular: ShapeRectHIcon64Regular,
    },
};
export var ShapeRectHIcon = forwardRef('ShapeRectHIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
